'use strict';

import React, { Component, useDebugValue, useState, useEffect, useCallback, useRef, useContext } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMMYYYYHHMM, getHyphenDDMMMYYYY, getHyphenYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS, getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS, getCellValue, findByFieldIgnoreCase, isSameIgnoreCase } from '../common/utils';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import { verifyext, verifycsvdata } from "../common/verifyext";
import { Edit, Trash } from 'lucide-react';
import TransporterChildCodesModal from './transporterChildCodesModal';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import AddEditController from './addEditController.js';
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent = "";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;

// ---------------------------------------------------------------------------------------------
// Transporter child codes on the ADD form (QA, 2026-10-21).
// Child codes are mandatory. A deleted transporter's codes are deleted with it, so a transporter
// that is new - or re-added after a delete - has none on its tab and must be given them here. One
// that already has codes on the tab may leave the field blank (the new row takes its list); codes
// typed for it are ADDED to that list. Checked while the form is still open, so the warning shows
// on top of it and nothing typed is lost; the server checks again when it saves.
function parseChildCodes(value) {
    var out = [];
    String(value || "").split(/[,;\s]+/).forEach(function (raw) {
        var code = String(raw || "").trim().toUpperCase();
        if (code && out.indexOf(code) < 0) { out.push(code); }
    });
    return out;
}

function childCodesField(tabParamsFn) {
    return {
        id: 90,
        title: "Transporter Child Codes",
        field: "child_codes",
        type: "input",
        input_type: "text",
        errMsg: "Please enter the Transporter Child Codes.",
        is_active: true,
        is_disabled: false,
        is_required: true,
        note: "The codes MSIL's dispatch feed reports this transporter under, comma separated. "
            + "Mandatory when the transporter has none on this tab (new, or re-added after a "
            + "delete). Codes typed for a transporter that already has some are added to its list.",
        validate: async function (value, all) {
            var codes = parseChildCodes(value);
            var code = String((all && all.transporter_code) || "").trim().toUpperCase();
            if (!code) { return null; }        // the Transporter Code field reports that itself
            try {
                var r = await redirectURL.post("/lmconsignees/checkTransporterChildCodes",
                    Object.assign(tabParamsFn(), { transporter_code: code, child_codes: codes }));
                var d = (r && r.data) || {};
                if (codes.length === 0 && (d.existing_codes || []).length === 0) {
                    return "Transporter Child Codes are mandatory - " + code + " has no child codes "
                         + "on this tab. Enter at least one (comma separated).";
                }
                var clashes = d.clashes || [];
                if (clashes.length > 0) {
                    return "These child codes already belong to another transporter: "
                         + clashes.map(function (c) {
                               return c.child_code + " -> " + (c.transporter_name || c.transporter_code)
                                    + " (" + c.transporter_code + ")";
                           }).join(", ")
                         + ". A child code can belong to only one transporter.";
                }
                return null;
            } catch (e) {
                // Could not check: still insist on a list when none was typed; the server
                // re-checks clashes when it saves.
                return codes.length === 0
                    ? "Transporter Child Codes are mandatory - enter at least one (comma separated)."
                    : null;
            }
        }
    };
}

// BULK UPLOAD (every tab): the same mandatory rule as the Add form, checked before anything is
// posted. Per transporter in the sheet: the codes typed in its TRANSPORTER CHILD CODES cells (any of
// its rows) + what it already has on this tab. Returns a warning message, or null when the upload may
// go ahead. Refuses: a transporter with no codes anywhere, a code another transporter holds, and one
// code typed for two different transporters in the same sheet.
async function bulkChildCodesProblem(rows, tabParams) {
    var byCode = {};
    var order = [];
    (rows || []).forEach(function (r) {
        var code = String(r.transporter_code || "").trim().toUpperCase();
        if (!code) { return; }
        if (!byCode[code]) { byCode[code] = []; order.push(code); }
        parseChildCodes(r.child_codes).forEach(function (c) {
            if (byCode[code].indexOf(c) < 0) { byCode[code].push(c); }
        });
    });
    var missing = [];
    var clashLines = [];
    var typedOwner = {};
    order.forEach(function (code) {
        byCode[code].forEach(function (c) {
            if (typedOwner[c] !== undefined && typedOwner[c] !== code) {
                clashLines.push(c + " is typed for both " + typedOwner[c] + " and " + code);
            }
            typedOwner[c] = code;
        });
    });
    for (var i = 0; i < order.length; i++) {
        var code = order[i];
        var r;
        try {
            r = await redirectURL.post("/lmconsignees/checkTransporterChildCodes",
                Object.assign({}, tabParams, { transporter_code: code, child_codes: byCode[code] }));
        } catch (e) {
            return "Nothing was uploaded - the transporter child codes could not be checked ("
                 + (e && e.message ? e.message : "network error") + "). Please try again.";
        }
        var d = (r && r.data) || {};
        if (byCode[code].length === 0 && (d.existing_codes || []).length === 0) { missing.push(code); }
        (d.clashes || []).forEach(function (c) {
            clashLines.push(c.child_code + " (typed for " + code + ") already belongs to "
                            + (c.transporter_name || c.transporter_code) + " (" + c.transporter_code + ")");
        });
    }
    if (missing.length === 0 && clashLines.length === 0) { return null; }
    var msg = "Nothing was uploaded.";
    if (missing.length > 0) {
        msg += " Transporter Child Codes are mandatory - these transporters have none on this tab: "
             + missing.join(", ") + ". Fill the TRANSPORTER CHILD CODES column for them (comma separated).";
    }
    if (clashLines.length > 0) {
        msg += " A child code can belong to only one transporter: " + clashLines.join("; ") + ".";
    }
    return msg;
}

// Reads the answer of /updateHubTransporter: {status, message, missing_child_codes}.
// ok = the rows were saved (a child-code problem after that is a warning, not a failure).
function transporterSaveAlert(data, okTitle) {
    data = data || {};
    if (data.status === "failure") {
        return { ok: false, type: "warning", title: data.message || "Could not save." };
    }
    if (data.status === "warning") {
        return { ok: true, type: "warning", title: data.message };
    }
    var missing = data.missing_child_codes || [];
    if (missing.length > 0) {
        return { ok: true, type: "warning",
                 title: okTitle + " Transporter child codes are mandatory and still missing on this "
                      + "tab for: " + missing.join(", ") + ". Set them in Transporter Child Codes." };
    }
    return { ok: true, type: "success", title: okTitle };
}


export default class LmTransporters extends Component {
    static contextType = LoadingPortContext;

    constructor(props, context) {
        super(props, context);
        this._lastLoadingPortCode = context ? context.loading_port_code : null;
        this.state = {
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                editable: true,
            },
            eventAction: null,
            show: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions,
                actionRenderer: this.ActionRenderer
            },
            modified_by: "",
            basicTitle: '',
            reasonforceclose: "",
            bulkslide: "",
            file: "",
            uploadFile: "",
            basicType: "default",
            loadshow: 'show-n',
            forceCloseRowNode: "",
            forceclosedata: "",
            csvcontent: "",
            sliderForceCloseTranslate: "",
            overly: '',
            rowData: [],
            bulkslide: "",
            showDiv: "",
            uploadDivWidth: "",
            mapinfo: "",
            dealer: "",
            sliderCommentTranslate: "",
            commentsRowData: "",
            consignment_code: "",
            sliderRouteTranslate: "",
            maptruckno: "",
            routeTruck: "",
            rownode: "",
            googelRoutes: "",
            file: "",
            rowSelection: 'multiple',
            sliderForceCloseTranslate: "",
            maptruckno: "",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            paginationPageSize: 200,
            geofencelist: [],
            geoFenceData: "",
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            animateRows: true,
            dept_code: "",
            pagetitle: "",
            markDeliverRowNode: "",
            markDeliverData: "",
            sliderMarkDeliverTranslate: "",
            csvData: 0,
            overly: "show-n",
            loadshow: "show-n",
            trnsportersList: [],
            statesList: [],
            sobZones: [],
            vehicleList: [],
            showCalendar: "show-m",
            showGridData: "show-m",
            comp_code: "",
            lpNames: [],
            loading_port_code: "",
            data_type: 1,
            regularActive: "activet",
            truckActive: "",
            courierActive: "", airCourierActive: "",
            controller: {
                open: false
            }, selectedRows: [], errors: [], validData: [],
            // Is the tab-wide Transporter Child Codes configuration open?
            childCodesOpen: false
            //components : {datepicker:getDatePicker()}
        }
        this.changeFileHandler = this.changeFileHandler.bind(this);
        this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
        this.onCellClicked = this.onCellClicked.bind(this);
        this.checkFileData = this.checkFileData.bind(this);
        this.gridRef = React.createRef();
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        loadDateTimeScript();
        this.pageAccess();

        redirectURL.post("/lmconsignees/getLmStates").then((response) => {
            var states = response.data;
            // var statesList = [];
            // if (states.length > 0) {
            //     states.map((item) => {
            //         statesList.push(item.state)
            //     })
            // }
            this.setState({
                statesList: states,
            })
        }).catch((e) => {
            console.log(e);
        })
    }

    // Zone used to be derived from the States master's global (not warehouse-
    // scoped) state->zone mapping. That's inconsistent with every other master
    // (Vehicle Details, Route Configurations) that already derives zone from the
    // per-warehouse SOB Zones master - a transporter record is itself already
    // scoped by loading_port_code on every read/write, so there's no reason its
    // zone shouldn't be too. State selection itself still comes from the States
    // master; only the zone lookup switches source.
    fetchSobZones = (loading_port_code) => {
        return redirectURL.post("/lmconsignees/getLmSobZones", { loading_port_code }).then((response) => {
            this.setState({ sobZones: response.data || [] });
        }).catch((e) => {
            console.log(e);
        });
    }

    getZoneForState = (state) => {
        var match = (this.state.sobZones || []).find((each) => isSameIgnoreCase(each.state, state));
        return match ? match.zone : "";
    }

    async pageAccess() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var currentUrl = this.props.match.path;
        var resolved = await resolvePageAccess(currentUrl, this.context);
        if (!resolved) {
            // No access (already alerted+redirected), empty port list, or a logged request error.
            this.setState({ loadshow: 'show-n', overly: 'show-n' });
            return;
        }
        this._lastLoadingPortCode = resolved.loading_port_code;
        this.setState({
            pageAccess: resolved.pageAccess,
            loading_port_code: resolved.loading_port_code,
            comp_code: resolved.comp_code,
            lpNames: resolved.lpNames,
        });
        await this.fetchSobZones(resolved.loading_port_code);
        await this.onLoadPageData();
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
        })
    }

    onLoadPageData = async () => {

        var loading_port_code = this.state.loading_port_code;
        var data_type = this.state.data_type;
        var params = {
            loading_port_code: loading_port_code,
            data_type: data_type, air_courier_transporter: this.state.airCourierActive == "activet" ? 1 : 0
        }
        await redirectURL.post("/lmconsignees/getLmTransporters", params).then((response) => {
            console.log(response.data);
            this.setState({
                rowData: response.data
            })
            console.log(response.data.filter((each) => each.transporter_name == "BARODA FREIGHT CARRIERS"))
        }).catch((e) => {
            console.log(e);
        })

        await redirectURL.post("/lmconsignees/getLmVehicleCapacity", params).then((response) => {
            var lmvehs = response.data;
            // var vehicleList = [];
            // if (lmvehs.length > 0) {
            //     lmvehs.map((item) => {
            //         vehicleList.push(item.vehicle_cap)
            //     })
            // }
            this.setState({
                vehicleList: lmvehs,
            })
        }).catch((e) => {
            console.log(e);
        })

        await redirectURL.post('/lmconsignees/prtTransportersList', params)
            .then((response) => {
                //console.log(response.data);
                var transporters = response.data;
                // var trnsportersList = [];
                // if (transporters.length > 0) {
                //     transporters.map((item) => {
                //         trnsportersList.push(item.transporter_name)
                //     })
                // }
                this.setState({
                    trnsportersList: transporters
                })
            })
            .catch(function (error) {
                console.log(error)
            });
    }

    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }



    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    onCellClicked(e) {
        if (e.colDef.field == "delete") {
            var rowId = e.data._id;
            console.log(e.data._id);
            var qry = {
                rowId: rowId,
                transporter_name: e.data.transporter_name,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
                data_type: this.state.data_type,
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are you sure you want to delete? The transporter child codes on the deleted row(s) are removed with them.")) {
                redirectURL.post("/lmconsignees/deleteLmTransporters", qry).then((response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true
                        })
                        window.location.reload();
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
    }

    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            bulkslide: "",
            controller: {
                open: false
            },
            fileName: "",
            errors: [],
            validData: [],
            showBulkSlider: false

        });

    }
    updateLmStates(params) {
        //console.log(params);
        if (params.transporter_name != '' && params.transporter_name != undefined && params.state != '' && params.state != undefined && params.vehicle_capacity != '' && params.vehicle_capacity != undefined) {
            var loading_port_code = this.state.loading_port_code;
            params["loading_port_code"] = loading_port_code;
            params['user_name'] = localStorage.getItem('username');
            params['email'] = localStorage.getItem('email');
            params['staff_id'] = localStorage.getItem('staff_id');
            params['user_department'] = localStorage.getItem('lm_department');
            params['designation'] = localStorage.getItem('designation');
            params['comp_code'] = this.state.comp_code;
            params['user_role'] = localStorage.getItem('roles');
            params['data_type'] = this.state.data_type;
            redirectURL.post("/lmconsignees/savelmtransporters", params).then((response) => {
                console.log(response);
                if (response.data.message == "Success") {
                    this.setState({
                        basicTitle: "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                    this.onLoadPageData();
                }
                else if (response.data.message == "Failure") {
                    this.setState({
                        basicTitle: "Transporter Data Already Exists.",
                        basicType: "warning",
                        show: true
                    })
                }
                else {
                    this.setState({
                        basicTitle: "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })
        }
        else {
            this.setState({
                basicTitle: "Fields Should not be Empty.",
                basicType: "warning",
                show: true
            })
        }
    }
    addNewRow() {
        var stateArray = this.state.statesList.map((each) => ({ label: each.state, value: each.state, zone: each.zone }));
        // DEDUPE by vehicle_cap. vehicleList holds the RAW lmvehiclecapacity rows, which are keyed
        // (loading_port_code, zone, data_type) - one row PER ZONE - so mapping 1:1 repeated every
        // vehicle type once per zone (GUR: 7 hub zones => "32 FT HUB Vehicle" listed 7 times).
        // A transporter's vehicle type is warehouse-level, not zone-level. Keep vehicleList itself
        // un-deduped: the save paths look up `id` off it via .find(vehicle_cap == ...).
        var vehicleCapacityArray = [...new Set(this.state.vehicleList.map((each) => each.vehicle_cap))]
            .map((each) => ({ label: each, value: each }));
        var transporterArray = this.state.trnsportersList.map((each) => ({ label: each.transporter_name, value: each.transporter_code }));
        // var zoneArray = [... new Set(this.state.zoneArray.map((each) => each.zone))].map((each) => ({ label: each, value: each }));

        var resourceArray = [

            // {
            //     id: 1,
            //     title: "Transporter Name",
            //     field: "transporter_code",
            //     type: "dropdown",
            //     optionsArray: transporterArray,
            //     errMsg: "Please select a transporter.",
            //     is_active: true,
            //     is_disabled: false,
            //     is_required: true
            // },
            {
                id: 1,
                title: "Transporter Name",
                field: "transporter_name",
                type: "input",
                input_type: "text",
                errMsg: "Please enter Transporter Name.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 1,
                title: "Transporter Code",
                field: "transporter_code",
                type: "input",
                input_type: "text",
                errMsg: "Please enter Transporter Code.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "State",
                field: "state",
                type: "dropdown",
                optionsArray: stateArray,
                errMsg: "Please select a state.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "Vehicle Type",
                field: "vehicle_capacity",
                type: "dropdown",
                optionsArray: vehicleCapacityArray.filter((each) => each.value != "Courier"),
                errMsg: "Please select the vehicle type.",
                is_active: this.state.airCourierActive != "activet",
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Zone",
                field: "zone",
                type: "input",
                input_type: "text",
                errMsg: "Please enter the zone.",
                is_active: false,
                is_disabled: true,
                is_required: true
            },
            childCodesField(() => ({
                loading_port_code: this.state.loading_port_code,
                data_type: this.state.data_type,
                hub_transporter: 0,
                air_courier_transporter: this.state.airCourierActive === "activet" ? 1 : 0
            })),
        ];
        var titleLabel = "Add New Transporter"
        this.setState({
            controller: {
                open: true,
                title: titleLabel,
                btnType: "Add",
                formResourceArray: resourceArray || [],

                type: "add",
                formData: {}
            }
        })
    }
    showGrid() {
        this.setState({
            showCalendar: "show-n",
            showGridData: "show-m"
        })
    }
    onClickDataExport() {
        var params = {
            fileName: "transporters.csv"
        };
        this.gridApi.exportDataAsCsv(params);
    }
    showBulkUpload() {
        this.setState({
            overly: "show-m",
            bulkslide: "slider-translate",
            errors: [],
            validData: [],
            fileName: ""
        })
    }
    resetUpload = () => {
        this.setState({
            bulkslide: '',
            overly: 'show-n',
            file: ''
        });
        document.getElementById("upform").reset();
    }
    changeFileHandler = async (e) => {
        var dt = '';
        const config = {
            headers: [
                {
                    name: 'id',
                    inputName: 'id',
                    required: false,
                },
                {
                    name: 'Transporter',
                    inputName: 'transporter_name',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'State',
                    inputName: 'state',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Vehicle Type',
                    inputName: 'vehicle_capacity',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
            ]
        }
        var data = CSVFileValidator(e.target.files[0], config)
            .then((csvData) => {
                this.setState({
                    csvData: csvData.data
                });
                console.log(csvData.data);
            })
            .catch(err => { })
        // console.log("e.target.files[0]",e.target.result);

        var out = new Promise(function (reject, resolve) {
            var reader = new FileReader();
            reader.onload = async function (e) {
                var contents = await e.target.result;
                resolve(contents);
            };
            var tt = reader.readAsText(e.target.files[0]);
        });
        this.setState({
            file: e.target.files[0]
        });
        // console.log("e.target.files[0].type ", e.target.files[0]);

        if (e.target.files[0].type == '' || e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
            // console.log(fileData);
            // console.log(typeof(fileData))

        }
        else {
            e.target.value = null;
            this.setState({
                uploadFile: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'Please upload file having extensions .csv only.',
            });
        }

    }

    checkFileData() {

        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        //console.log("verifycsvdata ", vdata)
        if (vdata == 0) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
    }
    uploadBulkFormHandler(event) {
        event.preventDefault();
        var fileData = this.state.csvData;
        var flag = 0;
        console.log(fileData, "fileData");
        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        //console.log("verifycsvdata ", vdata)
        if (vdata == true) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
        else {
            if (flag == 0) {
                if (fileData.length > 0) {
                    var loading_port_code = this.state.loading_port_code;
                    var reqParams = {
                        csvData: fileData,
                        loading_port_code: loading_port_code
                    }
                    reqParams["loading_port_code"] = loading_port_code;
                    reqParams['user_name'] = localStorage.getItem('username');
                    reqParams['email'] = localStorage.getItem('email');
                    reqParams['staff_id'] = localStorage.getItem('staff_id');
                    reqParams['user_department'] = localStorage.getItem('lm_department');
                    reqParams['designation'] = localStorage.getItem('designation');
                    reqParams['comp_code'] = this.state.comp_code;
                    reqParams['user_role'] = localStorage.getItem('roles');
                    reqParams['data_type'] = this.state.data_type;
                    console.log("reqParams", reqParams)
                    redirectURL.post("/lmconsignees/savebulklmtransporters", reqParams).then((response) => {
                        var resp = response.data.message;
                        console.log(resp)
                        this.setState({
                            basicTitle: resp,
                            basicType: "success",
                            show: true,
                            bulkslide: '',
                            overly: 'show-n',
                        })
                        this.onLoadPageData();
                    }).catch((e) => {
                        console.log(e);
                    })
                }
                else {
                    this.setState({
                        basicTitle: "Invalid File",
                        basicType: "warning",
                        show: true,
                    })
                }
                $('#upform')[0].reset();
            }
            else {
                $("#bulkUploadID").val();
                this.setState({
                    basicTitle: "Fields Should not be Empty",
                    basicType: "warning",
                    show: true,
                })
                $('#upform')[0].reset();
            }
        }
    };




    onSelectBulkPlants = (location) => {
        var plants = [];
        try {
            location.map(function (e) {
                plants.push(e.value);
            })
            console.log(plants);
            this.setState({
                plant_name: plants
            });
        }
        catch (e) {
            console.log(e);
        }

    }

    componentDidUpdate() {
        if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
            this._lastLoadingPortCode = this.context.loading_port_code;
            this.onGlobalPortChange();
        }
    }
    onGlobalPortChange = () => {
        var selectedPlant = this.context.loading_port_code;
        if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection, don't refetch.
            return;
        }
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var params = {
            selectedPlant: selectedPlant,
        }
        redirectURL.post("/lmconsignees/getLoadingPlantDetails", params)
            .then((response) => {
                var res = response.data;

                console.log(selectedPlant, "selectedPlant")
                this.setState({
                    loading_port_code: selectedPlant,
                    comp_code: res[0].comp_code,

                }, async () => {
                    await this.fetchSobZones(selectedPlant);
                    await this.onLoadPageData();
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                    })
                })
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }


    onClickTab = async (data_type, type) => {
        var regularActive = "";
        var truckActive = "";
        var courierActive = "";
        var hubActive = "";
        var airCourierActive = "";
        if (data_type == 1 && type !== "hub") {
            regularActive = "activet";
        }
        else if (data_type == 2 && type != "airCourier") {
            truckActive = "activet";
        }
        else if (data_type == 3) {
            courierActive = "activet";
        } else if (data_type == 1 && type === "hub") {
            hubActive = "activet";
        } else if (data_type == 2 && type === "airCourier") {
            airCourierActive = "activet";
        }
        this.setState({
            data_type: data_type,
            // The child-codes pop-up belongs to ONE tab - its list, and what a save writes to, are
            // both scoped to the tab it was opened from. Leaving it open across a tab switch left
            // "Transporter child codes - Regular" sitting over the Hub grid, which reads as the
            // wrong tab's data and would save to the wrong tab if used.
            childCodesOpen: false,
            regularActive: regularActive,
            truckActive: truckActive,
            courierActive: courierActive,
            airCourierActive: airCourierActive,
            hubActive: hubActive,
            loadshow: 'show-m',
            overly: 'show-m',
        }, async () => {
            if (type == "hub") {
                return
            }
            await this.onLoadPageData();
            this.setState({
                loadshow: 'show-n',
                overly: 'show-n',
            })
        });
        // await this.onLoadPageData();
    }
    ActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

            <Edit className="text-primary cursor-pointer ml-2 d-none"
                size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleEdit(props) }} />
            <Trash className="text-danger cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { this.deleteTransporterData([props.data]) }} />
        </div>
    );

    onUpdateTransporter = async (object) => {
        console.log(object)
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var correctedObject = {
            "loading_port_code": this.state.loading_port_code,
            "transporter_code": object.transporter_code,
            "transporter_name": object.transporter_name,
            "state": object.state,
            "zone": this.getZoneForState(object.state),
            "vehicle_capacity": object.vehicle_capacity,
            "vehicle_capacity_id":
                (
                    this.state.vehicleList.find(
                        (each) => each.vehicle_cap === object.vehicle_capacity
                    ) || {}
                ).id || "AIR_COURIER",
            "status": 1, "hub_transporter": 0, air_courier_transporter: this.state.airCourierActive === "activet" ? 1 : 0,
            "data_type": this.state.data_type,
            // typed on the Add form; written to every row of this transporter on this tab
            "child_codes": parseChildCodes(object.child_codes),
        }
        console.log(object, correctedObject)
        await this.bulkUpdateTransporter([correctedObject], this.state.controller.type)
        await this.onLoadPageData();
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            controller: {
                open: false
            }
        })
    }
    bulkUpdateTransporter = async (array, type = "add") => {
        // console.log(object)
        var params = {
            data: array,
            comp_code: this.state.comp_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        }
        try {

            const response = await redirectURL.post("/lmconsignees/updateHubTransporter", params);
            // Was `status == "success"`, a field the route never sent - so no confirmation was
            // ever shown. It now answers success / warning (rows saved, child codes not, or still
            // missing on the tab) / failure (a child code clash - nothing saved).
            var alert = transporterSaveAlert(response.data,
                type === "update" ? "Updated Successfully." : "Added Successfully.");
            this.setState({
                basicTitle: alert.title,
                basicType: alert.type,
                show: true
            })
        } catch (error) {
            console.log(error)
            this.setState({
                basicTitle: "Could not save the transporter.",
                basicType: "danger",
                show: true
            })
        }
    }
    deleteTransporterData = async (data) => {
        console.log(data)
        var rowIds = data.map((each) => each._id);
        var port = data[0].loading_port_code
        // console.log(loadingPortCode, "rowIds")

        if (rowIds.length > 0) {
            this.setState({
                loadshow: 'show-m',
                overly: 'show-m',
            })
            var qry = {
                rowIds: rowIds,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are you sure you want to delete? The transporter child codes on the deleted row(s) are removed with them.")) {
                redirectURL.post("/lmconsignees/deleteBulkLmHubTransporter", qry).then(async (response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {

                        //window.location.reload();
                        await this.onLoadPageData();
                        this.setState({
                            loadshow: 'show-n',
                            overly: 'show-n',
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true,
                            selectedRows: []
                        })
                    }
                    else {

                    }
                }).catch((e) => {
                    console.log(e);
                })
            } else {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n'
                })
            }
        }
        else {
            this.setState({
                show: true,
                basicType: "warning",
                basicTitle: "Please select the Row(s) to continue."
            });
        }
    }
    onExportClick = () => {
        if (this.gridRef.current && this.gridRef.current.api) {
            // this.gridRef.current.api.exportDataAsCsv();
            this.gridRef.current.api.exportDataAsExcel({
                fileName: "transporters.xlsx"
            });
        }
    };
    getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };
    isValidNumber = (value) => {
        const str = String(value || "").trim();
        return str !== "" && /^-?\d+(\.\d+)?$/.test(str);
    };

    handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        this.setState({ fileName: file.name })

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            this.validateExcelData(data);
        };
    };

    // ================= VALIDATION =================


    validateExcelData = (data) => {

        let errorList = [];
        let cleanedData = [];
        console.log(data)

        data.forEach((row, index) => {

            const rowNumber = index + 2; // Excel row (header = 1)

            let stateInput = String(getCellValue(row, "STATE") || "").trim()

            let transporterName = String(getCellValue(row, "TRANSPORTER NAME") || "").trim()
            let transporterCode = String(getCellValue(row, "TRANSPORTER CODE") || "").trim()
            let vehicleCapacityInput = String(getCellValue(row, "VEHICLE TYPE") || "").trim()

            let rowErrors = [];

            // ---- State ----
            const matchedState = findByFieldIgnoreCase(this.state.statesList, "state", stateInput);
            let state = matchedState ? matchedState.state : stateInput;
            if (!matchedState) {
                rowErrors.push(`State - "${stateInput}" does not exist in available states.`);
            }

            if (!transporterName) {
                rowErrors.push(`Please enter Transporter Name`);
            }
            if (!transporterCode) {
                rowErrors.push(`Please enter Transporter Code`);
            }
            const matchedVehicleCapacity = findByFieldIgnoreCase(this.state.vehicleList, "vehicle_cap", vehicleCapacityInput);
            let vehicleCapacity = matchedVehicleCapacity ? matchedVehicleCapacity.vehicle_cap : vehicleCapacityInput;
            if (!matchedVehicleCapacity && this.state.airCourierActive !== "activet") {
                rowErrors.push(`Vehicle Capacity - "${vehicleCapacityInput}" does not exist in available vehicles".`);
            }

            // ---- Collect Errors ----
            if (rowErrors.length > 0) {
                errorList.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {
                cleanedData.push({
                    state: state,
                    transporter_name: transporterName,
                    transporter_code: transporterCode,
                    vehicle_capacity: this.state.airCourierActive === "activet" ? "AIR_COURIER" : vehicleCapacity,
                    // optional column - checked as a whole in handleBulkUpload (bulkChildCodesProblem)
                    child_codes: String(getCellValue(row, "TRANSPORTER CHILD CODES") || "").trim()

                });
            }
        });

        if (cleanedData.length == 0 && errorList.length == 0) {
            errorList.push({
                row: "",
                errors: ["No Data found. All rows are empty"]
            });
        }

        this.setState({

            errors: errorList,
            validData: cleanedData
        })

        console.log("Valid Data:", cleanedData);
        console.log("Errors:", errorList);
    };

    checkTransporterIdentity = (transporter_name) => {
        return this.state.trnsportersList.some(
            (each) => (each.transporter_name === transporter_name)
        );
    };

    handleBulkUpload = async () => {

        try {
            this.setState({
                loadshow: "show-m",
                overly: "show-m"
            })

            const finalData = this.state.validData.map((each) => {
                return (
                    {
                        ...each,
                        // "transporter_code": this.state.trnsportersList.find((object) => each.transporter_name == object.transporter_name).transporter_code,
                        "zone": this.getZoneForState(each.state),
                        // "vehicle_capacity_id": this.state.vehicleList.find((object) => each.vehicle_capacity == object.vehicle_cap).id,
                        "vehicle_capacity_id":
                            (
                                this.state.vehicleList.find(
                                    (object) => each.vehicle_capacity === object.vehicle_cap
                                ) || {}
                            ).id || "AIR_COURIER",
                        "loading_port_code": this.state.loading_port_code,
                        // "comp_short_name": loadingPortData.find((object) => object.value == loadingPortCode).label || "",
                        "status": 1, "hub_transporter": 0, air_courier_transporter: this.state.airCourierActive == "activet" ? 1 : 0,
                        "data_type": this.state.data_type,
                        "child_codes": parseChildCodes(each.child_codes),

                    }
                )
            })
            // console.log(this.state.validData, finalData)

            // Child codes are mandatory - refuse the whole upload (nothing posted) when a
            // transporter would be left without any, or a typed code clashes.
            var problem = await bulkChildCodesProblem(finalData, {
                loading_port_code: this.state.loading_port_code,
                data_type: this.state.data_type,
                hub_transporter: 0,
                air_courier_transporter: this.state.airCourierActive == "activet" ? 1 : 0
            });
            if (problem) {
                // shown in the slider's own Validation Errors table - it stays open for a fix
                this.setState({ loadshow: "show-n", overly: "show-n",
                                errors: [{ row: "-", errors: [problem] }].concat(
                                    (this.state.errors || []).filter(function (e) { return e.row !== "-"; })) });
                return;
            }

            await this.bulkUpdateTransporter(finalData, "add")
            await this.onLoadPageData();
            this.setState({
                loadshow: "show-n",
                overly: "show-n",
                errors: [],
                validData: [],
                bulkslide: false,
                fileName: "",

            })
            if (this.fileInputRef.current) {
                this.fileInputRef.current.value = "";
            }


            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };

    render() {
        var showActions = false;
        var showDelete = true;
        if (this.state.pageAccess == 2) {
            var showActions = true;
        }
        if (this.state.pageAccess == 3) {
            var showDelete = false;
        }
        var columnwithDefs = [
            {
                headerName: "",
                field: "_id",
                colId: "_id",
                width: 85,
                pinned: 'left',
                filter: false, resizable: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true,
                cellRenderer: "actionRenderer",

            },
            {
                headerName: "Transporter Name",
                field: "transporter_name",
                minWidth: 220,
                filter: true,
                resizable: true, flex: 1.6
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.trnsportersList,
                // },
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                minWidth: 140,
                filter: true,
                resizable: true, flex: 0.9
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.trnsportersList,
                // },
            },

            {
                headerName: "State",
                field: "state",
                minWidth: 140,
                filter: true,
                resizable: true, flex: 1
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.statesList,
                // },
            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_capacity",
                minWidth: 150,
                filter: true,
                resizable: true, flex: 1,
                hide: this.state.airCourierActive == "activet"
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.vehicleList,
                // },
            },
            {
                headerName: "Zone",
                field: "zone",
                minWidth: 110,
                filter: true,
                resizable: true, flex: 0.8
                // editable: false,
            },
            // TRANSPORTER CHILD CODES - shown here, but NOT editable here. They belong to the
            // TRANSPORTER, not to this row (a transporter has one row per state / vehicle type),
            // so an edit action on the row would read as "set these again for every row". Editing
            // lives behind the Transporter Child Codes button, which lists each LSP once.
            {
                headerName: "Transporter Child Codes",
                field: "child_codes",
                minWidth: 280,
                filter: true,
                resizable: true, flex: 2.2,
                valueGetter: function (params) {
                    var codes = (params.data && params.data.child_codes) || [];
                    return Array.isArray(codes) ? codes.join(", ") : String(codes || "");
                },
                tooltipValueGetter: function (params) {
                    var codes = (params.data && params.data.child_codes) || [];
                    return Array.isArray(codes) && codes.length > 0
                        ? codes.join(", ")
                        : "No transporter child code defined yet";
                },
                cellRenderer: function (params) {
                    var codes = (params.data && params.data.child_codes) || [];
                    return Array.isArray(codes) && codes.length > 0
                        ? codes.join(", ")
                        : '<span style="color:#b45309">Not defined</span>';
                }
            },
            {
                pinned: "left",
                headerName: "Update",
                field: "_id",
                width: 150,
                resizable: true,
                editable: false,
                cellRendererSelector: function (params) {
                    var rendComponent = {
                        component: 'UpdateButton'
                    };
                    return rendComponent;
                },
                hide: true,
            },
            {
                pinned: "left",
                headerName: "Delete",
                field: "delete",
                width: 80,
                resizable: true,
                editable: false,
                cellRenderer: function (params) {
                    return '<i class="icofont icofont-ui-delete"></i>';
                },
                hide: true,
            },
            {
                pinned: "left",
                headerName: "id",
                field: "id",
                width: 100,
                filter: true,
                resizable: true,
                editable: false,
                hide: true
            },
        ]
        var userroles = localStorage.getItem("roles")
        var errTrueUpload = this.state.errors.length > 0 && this.state.validData.length > 0
        var disableUpload = this.state.validData.length == 0
        console.log(this.state.trnsportersList)
        return (
            <div class="container-fluid" style={{ height: "100%" }}>
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                <TransporterChildCodesModal
                    open={this.state.childCodesOpen}
                    loadingPortCode={this.state.loading_port_code}
                    dataType={this.state.data_type}
                    hubTransporter={0}
                    airCourierTransporter={this.state.airCourierActive == "activet" ? 1 : 0}
                    tabLabel={this.state.airCourierActive == "activet" ? "Air Courier"
                              : this.state.data_type == 3 ? "Dedicated"
                              : this.state.data_type == 2 ? "Courier" : "Regular"}
                    readOnly={this.state.pageAccess == 2}
                    onSaved={() => this.onLoadPageData()}
                    onClose={() => this.setState({ childCodesOpen: false })} />
                {/* {(this.state.loading_port_code == "GUR") ? */}
                <div className="row col-sm-12" style={{ marginBottom: "10px" }}>
                    <ul
                        style={{
                            display: "inline-flex",
                            flexWrap: "wrap",      // 🔥 prevents cutting
                            padding: "4px",
                            margin: 0,
                            listStyle: "none",
                            gap: "4px",
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                        }}
                    >
                        {[
                            { onClick: () => this.onClickTab(1, "hub"), label: "Hub", active: this.state.hubActive },
                            { onClick: () => this.onClickTab(1, ""), label: "Regular", active: this.state.regularActive },
                            { onClick: () => this.onClickTab(3, ""), label: "Dedicated", active: this.state.courierActive },
                            { onClick: () => this.onClickTab(2, ""), label: "Surface Courier", active: this.state.truckActive },
                            { onClick: () => this.onClickTab(2, "airCourier"), label: "Air Courier", active: this.state.airCourierActive },
                        ].map(({ onClick, label, active }, idx) => {
                            var isActive = active == "activet";
                            return (
                                <li key={idx} onClick={onClick} style={{ listStyle: "none" }}>
                                    <button
                                        type="button"
                                        style={{
                                            whiteSpace: "nowrap",
                                            border: "none",
                                            outline: "none",
                                            borderRadius: "999px",
                                            padding: "8px 18px",
                                            fontSize: "13px",
                                            fontWeight: isActive ? 600 : 500,
                                            cursor: "pointer",
                                            transition: "all 0.2s ease",
                                            backgroundColor: isActive ? "#1976d2" : "transparent",
                                            color: isActive ? "#fff" : "#555",
                                            boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                        }}
                                    >
                                        {label}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {/* : ""} */}

                {
                    this.state.hubActive == "activet" ?
                        <HubTransporterPage pageAccess={this.state.pageAccess} />
                        :
                        <>
                            <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", height: "90%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                                <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0 }}>
                                    <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                                        <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                                        <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Transporters</h5>
                                    </div>
                                    <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                                        {this.state.selectedRows.length > 0 && <button
                                            className="pill-btn pill-btn-danger"
                                            onClick={() => { this.deleteTransporterData(this.state.selectedRows || []) }}
                                            disabled={this.state.selectedRows.length == 0}
                                        >
                                            Delete Selected
                                        </button>}
                                        <button className="pill-btn pill-btn-primary" onClick={this.onExportClick.bind(this)}>Export Data</button>
                                        {/* Tab-wide, not per row: the codes belong to the LSP, and
                                            this lists each LSP once. View-only access still opens
                                            it - the pop-up hides its own edit actions. */}
                                        <button className="pill-btn pill-btn-info"
                                                onClick={() => this.setState({ childCodesOpen: true })}>
                                            Transporter Child Codes
                                        </button>
                                        {(this.state.pageAccess != 2) ?
                                            <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                                            : ""}
                                        {(this.state.pageAccess != 2) ?
                                            <button className="pill-btn pill-btn-success" onClick={this.addNewRow.bind(this)}>+ Add</button>
                                            : ""}
                                    </div>
                                </div>
                                {/* {(this.state.lpNames.length > 0) ?
                                    <div className="row col-xl-12 col-lg-12" style={{ marginTop: "2%" }}>
                                        <div className="col-xl-12 col-lg-12">
                                            {this.state.lpNames.length == 1 ?
                                                <span style={{ fontSize: "16px" }}>Loading Plant : {(this.state.lpNames[0].loading_port)}</span>
                                                :
                                                <span style={{ fontSize: "16px" }}>Loading Plant :
                                                    <select id="loadingPlant" onChange={this.onChangeLoadingPlant.bind(this)}>
                                                        {(this.state.lpNames).map(function (obj) {
                                                            return <option value={obj.loading_port_code}>{obj.loading_port}</option>
                                                        })}
                                                    </select>
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    : ""} */}
                                <div className="card-body col-xl-12 col-lg-12 d-none">
                                    <div id="myGrid" style={{ width: "100%", height: "478px" }} className={"ag-theme-balham " + this.state.showGridData}>
                                        <AgGridReact
                                            modules={this.state.modules}
                                            columnDefs={columnwithDefs}
                                            defaultColDef={this.state.defaultColDef}
                                            rowData={this.state.rowData}
                                            enableCharts={false}
                                            // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                            onGridReady={this.onGridReady}
                                            onGridState={this.onGridState}
                                            frameworkComponents={this.state.frameworkComponents}
                                            statusBar={this.state.statusBar}
                                            sideBar={this.state.sideBar}
                                            rowHeight={45}
                                            headerHeight={45}
                                            stopEditingWhenGridLosesFocus={true}
                                            paginationPageSize={this.state.paginationPageSize}
                                            pagination={true}
                                            gridOptions={{
                                                context: { componentParent: this }
                                            }}
                                            // components={this.state.components}
                                            enableRangeSelection={true}
                                            onCellClicked={this.onCellClicked}
                                        // onCellEditingStopped={this.onCellUpdateData.bind(this)}
                                        />
                                    </div>
                                </div>
                                <div className="ag-theme-balham grid-wrapper mt-3 mb-3 px-3" style={{ flex: 1, minHeight: 0 }}>
                                    <AgGridReact
                                        ref={this.gridRef}
                                        modules={this.state.modules}
                                        rowData={this.state.rowData}
                                        columnDefs={columnwithDefs}
                                        defaultColDef={{
                                            sortable: true,
                                            filter: true,
                                            floatingFilter: true, resizable: true
                                        }}
                                        statusBar={{
                                            statusPanels: [
                                                { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                                { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                                { statusPanel: "agTotalRowCountComponent", align: "right" }
                                            ]
                                        }}
                                        animateRows rowSelection={"multiple"}
                                        rowHeight={45}
                                        headerHeight={45}
                                        frameworkComponents={this.state.frameworkComponents}
                                        onSelectionChanged={() => {
                                            if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                                                const selected = this.gridRef.current.api.getSelectedRows();
                                                this.setState({ selectedRows: selected })

                                            }
                                        }} suppressRowClickSelection={true}
                                    />
                                </div>
                            </div>
                            {this.state.controller.open && (
                                <>
                                    <div
                                        className="slider-overlay"
                                        onClick={this.onClickHideAll.bind(this)}
                                    />
                                    <AddEditController
                                        resource={this.state.controller}
                                        onUpdate={this.onUpdateTransporter}
                                        closeSlider={this.onClickHideAll.bind(this)}
                                    />
                                </>
                            )}
                            <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

                                <div className="slider-header">
                                    Import Data
                                    <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
                                </div>

                                <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                                    <input
                                        ref={this.fileInputRef}
                                        type="file"
                                        accept=".xlsx,.xls,.csv"
                                        onChange={this.handleFileChange}
                                        style={{ display: "none" }}
                                    />
                                    {/* Upload button */}
                                    <div className="d-flex align-items-center gap-3">
                                        <button
                                            className="btn btn-info d-flex justify-content-center p-3"
                                            type="button"
                                            onClick={() => this.fileInputRef.current.click()}
                                        >
                                            Upload File
                                        </button>

                                        <a href={
                                            this.state.airCourierActive == "activet"
                                                ? require("../../assets/air_courier_transporters.xlsx")
                                                : require("../../assets/transporters.xlsx")
                                        } className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                                            Download Sample Template
                                        </a>
                                    </div>

                                    {this.state.fileName && (
                                        <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                                            <span>Selected File :</span>
                                            <span
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    flex: 1,
                                                    fontWeight: "bold"
                                                }}
                                                title={this.state.fileName}
                                            >
                                                {this.getShortFileName(this.state.fileName)}
                                            </span>
                                        </div>
                                    )}


                                    {this.state.errors.length > 0 && (
                                        <>
                                            <h6 className="text-danger mt-3">Validation Errors</h6>

                                            <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                                                <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                                    <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                                        <tr>
                                                            <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                                            <th>Error Description</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {this.state.errors.map((err, i) => (
                                                            <tr key={i}>
                                                                <td className="text-center" style={{ padding: "9px 15px" }}>
                                                                    {err.row}
                                                                </td>

                                                                <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                                    {err.errors.map((e, idx) => (
                                                                        <p className="m-0" key={idx}>{e}</p>
                                                                    ))}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}

                                </div>
                                <div className="slider-footer">
                                    <button
                                        className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                                        onClick={this.handleBulkUpload}
                                        disabled={disableUpload}
                                    >
                                        {errTrueUpload ? "Submit only valid data" : "Submit"}
                                    </button>
                                </div>

                            </div>
                            {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
                            <div className={"slide-r d-none" + (this.state.bulkslide)} style={{ overflow: "hidden" }}>
                                <h3 className="subH">Bulk Upload</h3>
                                <div className="slide-r-body" style={{ position: "relative" }}>

                                    <div className="container-fluid">
                                        <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                                            <div className="form-group mt-20p">
                                                <label className="">Upload File</label>
                                                <input type="file" name="uploadFile" id="bulkUploadID" onChange={this.changeFileHandler} className="form-control" required />
                                            </div>
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-success">Submit</button>
                                                <button type="button" onClick={this.resetUpload.bind(this)} className="btn btn-default">Cancel</button>
                                            </div>
                                        </form>
                                        <div className="form-group">
                                            <a className="btn btn-primary" href={require('../../assets/json/sample_lmtransporters.csv')} target="_blank">Sample Template</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"dataLoadpage " + (this.state.loadshow)}>
                            </div>
                            <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                            </div>
                            <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
                        </>
                }
            </div>

        );
    }
}

function dateComparator1(date1, date2) {
    //console.log(date1,date2);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split("-")[1]);
        date1 = date1.replace(date1.split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split("-")[1]);
        date2 = date2.replace(date2.split("-")[1], date_2);
        var date1Number = monthToComparableNumber1(date1);
        var date2Number = monthToComparableNumber1(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}

function monthToComparableNumber1(date) {
    console.log(date.length);
    console.log(date);
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}
function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    console.log(yearNumber, monthNumber, dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}


function loadDateTimeScript() {
    // alert("timeDate");
    $('.datetimepicker_mask').datetimepicker({
        //mask:'39-19-9999 29:59',
        format: 'd-m-Y'
    });
    $('.datetimepicker_date').datetimepicker({
        mask: '39-19-9999',
        format: 'd-m-Y',
        timepicker: false
    });
    var index = window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src = "https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
    //script.src="http://xdsoft.net/jqplugins/datetimepicker/"
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}

function DateEditor() { }

// gets called once before the renderer is used
DateEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker: false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function () {
    // console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};





const HubTransporterPage = ({ page }) => {

    const gridRef = useRef();
    const portContext = useContext(LoadingPortContext);
    const lastPortRef = useRef(portContext.loading_port_code);

    const modules = [
        ClientSideRowModelModule,
        RowGroupingModule,
        MenuModule
    ];

    // ---------------- SLIDER STATE ----------------
    const [showSlider, setShowSlider] = useState(false);

    // ---------------- DROPDOWN ----------------
    const loadingPorts = [
        { value: "CHN", label: "Chennai" },
        { value: "MUM", label: "Mumbai" },
        { value: "KOL", label: "Kolkata" }
    ];




    // ---------------- FORM ----------------
    const [formData, setFormData] = useState({
        loading_port_code: null,
        hub_name: "",
        consignee_city: "",
        state: ""
    });

    const [hubData, setHubData] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [loadingPortData, setLoadingPortData] = useState([])
    const [showBulkSlider, setShowBulkSlider] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    const [hubTransporterData, setHubTransporterData] = useState([]);
    const [stateData, setStateData] = useState([])
    const [rowId, setRowId] = useState([])
    const [vehicleCapacityData, setVehicleCapacityData] = useState([])
    const [transporterData, setTransporterData] = useState([]);
    const [controller, setController] = useState({ open: false })

    const handleChange = e =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handlePortChange = (selected) => {
        // console.log(selected)
        setFormData({ ...formData, loading_port_code: selected.value, comp_short_name: selected.label });
    }

    // ---------------- VALIDATION ----------------
    const showValidationAlert = (message) => {
        setShow(true);
        setBasicType("warning");
        setBasicTitle(message);
    };

    const validateForm = () => {

        if (!formData.loading_port_code) {
            showValidationAlert("Select Loading Plant");
            return false;
        }

        if (!formData.hub_name) {
            showValidationAlert("Select Hub");
            return false;
        }

        if (!formData.consignee_city) {
            showValidationAlert("Select Consignee City");
            return false;
        }

        if (!formData.state) {
            showValidationAlert("Select State");
            return false;
        }

        if (!formData.vehicle_capacity) {
            showValidationAlert("Select Vehicle Capacity");
            return false;
        }

        if (!isValidNumber(formData.freight_rate)) {
            showValidationAlert("Freight Rate must be numeric");
            return false;
        }

        if (!formData.freight_type) {
            showValidationAlert("Select Freight Type");
            return false;
        }

        return true;
    };



    const closeSlider = () => {
        setShowSlider(false);
        setEditIndex(null);
        setFormData({
            loading_port_code: null,
            hub_name: null,
            consignee_city: null,
            state: null,
            vehicle_capacity: null,
            freight_rate: "",
            freight_type: ""
        });
    };


    const ActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

            <Edit className="text-primary cursor-pointer ml-2 d-none"
                size={15} style={{ cursor: "pointer" }} onClick={() => { editHubTransporter(props) }} />
            <Trash className="text-danger cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { handleDelete([props.data]); setRowId([props.data._id]) }} />
        </div>
    );
    // ---------------- GRID ----------------
    const components = {
        actionRenderer: ActionRenderer
    };
    const columnDefs = [
        {
            headerName: "",
            width: 100,
            cellRenderer: "actionRenderer",
            pinned: "left",
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true
        },
        // { headerName: "Source", field: "comp_short_name", flex: 1 },
        { headerName: "Transporter Name", field: "transporter_name", flex: 1.6, minWidth: 220 },
        { headerName: "Transporter Code", field: "transporter_code", flex: 0.9, minWidth: 140 },
        { headerName: "State", field: "state", flex: 1, minWidth: 140 },
        { headerName: "Vehicle Type", field: "vehicle_capacity", flex: 1.1, minWidth: 150 },
        {
            headerName: "Hub", field: "zone", flex: 0.9, minWidth: 120,
        },
        // Hub transporters keep their OWN MSIL child codes - a transporter's hub contract is
        // reported under different codes from its regular one, which is why the list is per tab.
        {
            headerName: "Transporter Child Codes", field: "child_codes", flex: 2.2, minWidth: 280,
            valueGetter: function (params) {
                var codes = (params.data && params.data.child_codes) || [];
                return Array.isArray(codes) ? codes.join(", ") : String(codes || "");
            },
            tooltipValueGetter: function (params) {
                var codes = (params.data && params.data.child_codes) || [];
                return Array.isArray(codes) && codes.length > 0
                    ? codes.join(", ")
                    : "No transporter child code defined for this hub transporter yet";
            },
            cellRenderer: function (params) {
                var codes = (params.data && params.data.child_codes) || [];
                return Array.isArray(codes) && codes.length > 0
                    ? codes.join(", ")
                    : '<span style="color:#b45309">Not defined</span>';
            }
        }
    ];

    useEffect(() => {
        const fetchData = async () => {
            setLoadshow("show-m")
            setOverly("show-m")
            var code = await pageAccessFn();
            // var code = await getLoadingPortCodeData();
            await getStateData();
            await getNecessaryData(code);
            setLoadshow("show-n")
            setOverly("show-n")
        }
        fetchData();
    }, []);

    const pageAccessFn = async () => {

        setLoadshow("show-m");
        setOverly("show-m");

        const currentUrl = window.location.pathname;

        try {
            const resolved = await resolvePageAccess(currentUrl, portContext);
            if (!resolved) {
                // No access (already alerted+redirected), empty port list, or a logged request error.
                return;
            }
            lastPortRef.current = resolved.loading_port_code;
            setPageAccess(resolved.pageAccess);
            setLoadingPortCode(resolved.loading_port_code);
            setCompCode(resolved.comp_code);
            setLoadingPortData(resolved.lpNames);
            return resolved.loading_port_code;
        } catch (err) {
            console.log(err);
        }

    };

    // React to the loading port changing from the header's global selector.
    useEffect(() => {
        if (portContext.loading_port_code !== lastPortRef.current) {
            lastPortRef.current = portContext.loading_port_code;
            onGlobalPortChange(portContext.loading_port_code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portContext.loading_port_code]);

    const onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant || !loadingPortData.some((each) => each.value == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection.
            return;
        }
        setLoadshow("show-m");
        setOverly("show-m");
        setLoadingPortCode(selectedPlant);
        await getNecessaryData(selectedPlant);
        setValidData([]);
        setErrors([]);
        setShowBulkSlider(false);
        setBulkFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setLoadshow("show-n");
        setOverly("show-n");
    };

    const getNecessaryData = async (port) => {
        await getHubData({ loading_port_code: port, is_active: 1 });
        await getLmTransporters({ loading_port_code: port, data_type: 1, status: 1 })
        await getVehicleCapacityData({ loading_port_code: port, data_type: 1, hub_vehicle: 1, status: 1 })
        await getHubTransporterData(port)
    }

    const getHubTransporterData = async (port) => {
        try {
            var params = {
                data_type: 1, hub_transporter: 1, status: 1, loading_port_code: port
            }
            const response = await redirectURL.post("/lmconsignees/getHubTransporterData", params);
            if (response.data.status == "success") {
                setHubTransporterData(response.data.data || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getHubData = async (params) => {
        try {
            const response = await redirectURL.post("/masters/getHubMasterData", params);
            if (response.data.status == "success") {
                setHubData(response.data.hubData
                    .map((each) => {
                        return { ...each, label: each.hub_name, value: each.hub_name }
                    })
                    || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getLoadingPortCodeData = async () => {
        try {
            var params = {

            }
            const response = await redirectURL.post("/lmconsignees/getLmLoadingPorts", params);
            // console.log(response)
            if (response.status == "200") {
                // console.log(response)
                setLoadingPortData(
                    response.data
                        ? response.data.map((each) => ({
                            ...each,
                            label: each.comp_short_name,
                            value: each.loading_port_code
                        }))
                        : []
                );
                setLoadingPortCode(response.data[0].loading_port_code)
                return response.data[0].loading_port_code;
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getLmTransporters = async (params) => {
        try {
            const response = await redirectURL.post("/lmconsignees/prtTransportersList", params);
            // console.log(response)
            if (response.status == "200") {
                setTransporterData(response.data || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getVehicleCapacityData = async (params) => {
        try {
            const response = await redirectURL.post("lmconsignees/getLmVehicleCapacity", params);
            // console.log(response)
            if (response.status == "200") {
                // console.log(response)
                setVehicleCapacityData(
                    response.data
                        ? response.data
                        // .filter((each) => each.vehicle_cap.includes("HUB")).map((each) => ({
                        //     ...each,
                        //     label: each.vehicle_cap,
                        //     value: each.vehicle_cap
                        // }))
                        : []
                );
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getStateData = async (params) => {
        try {
            const response = await redirectURL.post("/lmconsignees/getLmStates", params);
            // console.log(response)
            if (response.status == "200") {
                setStateData(response.data.map((each) => each.state) || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }


    const updateHubTransporter = async (array, type = "update") => {
        // console.log(object)
        var params = {
            data: array,
            comp_code: compCode,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        }
        try {

            const response = await redirectURL.post("/lmconsignees/updateHubTransporter", params);
            // success / warning (rows saved, child codes not - or still missing on the tab) /
            // failure (a child code clash - nothing saved). See transporterSaveAlert.
            var alert = transporterSaveAlert(response.data,
                type === "add" ? "Added Succesfully" : "Updated Succesfully");
            setShow(true)
            setBasicType(alert.type)
            setBasicTitle(alert.title)
        } catch (error) {
            console.log(error)
            setShow(true)
            setBasicType("danger")
            setBasicTitle("Could not save the transporter.")
        }
    }
    const deleteHubConsigneeData = async (payload) => {
        try {
            var params = payload
            const response = await redirectURL.post("/masters/deleteHubCityFreights", params);
            if (response.data.message == "Success") {
                setSelectedRows([])
                setShow(true)
                setBasicType("success")
                setBasicTitle("Deleted Succesfully")

            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleBulkUpload = async () => {

        try {
            setLoadshow("show-m")
            setOverly("show-m")
            //     var correctedObject = {
            //     "loading_port_code": loadingPortCode,
            //     "transporter_code": object.transporter_code,
            //     "transporter_name": transporterData.find((each) => each.transporter_code == object.transporter_code).transporter_name,
            //     "state": object.hub,
            //     "zone": object.hub,
            //     "vehicle_capacity": object.vehicle_cap,
            //     "vehicle_capacity_id": vehicleCapacityData.find((each) => each.vehicle_cap == object.vehicle_cap).id,
            //     "status": 1, "hub_transporter": 1,
            //     "data_type": 1,
            // }
            const finalData = validData.map((each) => {
                return (
                    {
                        ...each,
                        "state": each.zone,
                        "vehicle_capacity_id": vehicleCapacityData.find((object) => each.vehicle_capacity == object.vehicle_cap).id,
                        "loading_port_code": loadingPortCode,
                        // "comp_short_name": loadingPortData.find((object) => object.value == loadingPortCode).label || "",
                        "status": 1, "hub_transporter": 1,
                        "data_type": 1,
                        "child_codes": parseChildCodes(each.child_codes),

                    }
                )
            })
            // Child codes are mandatory - refuse the whole upload (nothing posted) when a
            // transporter would be left without any, or a typed code clashes.
            var problem = await bulkChildCodesProblem(finalData, {
                loading_port_code: loadingPortCode, data_type: 1,
                hub_transporter: 1, air_courier_transporter: 0
            });
            if (problem) {
                // shown in the slider's own Validation Errors table - it stays open for a fix
                setErrors([{ row: "-", errors: [problem] }].concat(
                    (errors || []).filter(function (e) { return e.row !== "-"; })));
                setLoadshow("show-n")
                setOverly("show-n")
                return;
            }
            console.log(validData, finalData)

            await updateHubTransporter(finalData, "add")
            await getHubTransporterData();
            setLoadshow("show-n")
            setOverly("show-n")
            setValidData([])
            setErrors([])
            setShowBulkSlider(false);
            setBulkFile(null);
            setFileName("");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }


            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };
    const downloadTemplate = async () => {
        const response = await redirectURL.post(
            "/masters/downloadHubTemplate",
            {}, // body if needed
            { responseType: "blob" } // important for Excel download
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Hub_Bulk_Upload_Template.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const handleDeleteSelected = async (port) => {
        const confirmDelete = window.confirm(
            "Are you sure to delete this record?"
        );

        // ✅ Exit function if Cancel clicked
        if (!confirmDelete) return;
        var payload = selectedRows.map((each) => {
            return {
                loading_port_code: each.loading_port_code,
                hub_name: each.hub_name,
                consignee_city: each.consignee_city,
                state: each.state,
                vehicle_capacity: formData.vehicle_capacity,
                is_active: 1
            }
        })
        setLoadshow("show-m")
        setOverly("show-m")
        await deleteHubConsigneeData(payload)
        await getHubTransporterData(port);
        setLoadshow("show-n")
        setOverly("show-n")
    }
    const [selectedRows, setSelectedRows] = useState([]);

    const [loadshow, setLoadshow] = useState("show-n")
    const [overly, setOverly] = useState("show-n")
    const [pageAccess, setPageAccess] = useState(page);
    // Is the tab-wide Transporter Child Codes configuration open?
    const [childCodesOpen, setChildCodesOpen] = useState(false);
    const [loadingPortCode, setLoadingPortCode] = useState("");
    const [compCode, setCompCode] = useState("");
    const [lpNames, setLpNames] = useState([]);
    const [errors, setErrors] = useState([]);
    const [validData, setValidData] = useState([]);
    const [fileName, setFileName] = useState("");

    const fileInputRef = useRef(null);
    const onClickHideAll = () => {
        // setLoadshow("show-n")
        // setOverly("show-n")

    }

    const isValidNumber = (value) => {
        const str = String(value || "").trim();
        return str !== "" && /^-?\d+(\.\d+)?$/.test(str);
    };

    const handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        setFileName(file.name); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            validateExcelData(data);
        };
    };

    // ================= VALIDATION =================



    const validateExcelData = (data) => {

        let errorList = [];
        let cleanedData = [];
        console.log(data)

        data.forEach((row, index) => {

            const rowNumber = index + 2; // Excel row (header = 1)

            let hubNameInput = String(getCellValue(row, "HUB") || "").trim()

            let transporterName = String(getCellValue(row, "TRANSPORTER NAME") || "").trim()
            let transporterCode = String(getCellValue(row, "TRANSPORTER CODE") || "").trim()
            let vehicleCapacityInput = String(getCellValue(row, "VEHICLE TYPE") || "").trim()

            let rowErrors = [];

            // ---- Hub Name ----
            const matchedHub = findByFieldIgnoreCase(hubData, "hub_name", hubNameInput);
            let hubName = matchedHub ? matchedHub.hub_name : hubNameInput;
            if (!matchedHub) {
                rowErrors.push(`Hub - "${hubNameInput}" does not exist in Hub Master.`);
            }

            if (!transporterName) {
                rowErrors.push(`Please enter Transporter Name`);
            }
            if (!transporterCode) {
                rowErrors.push(`Please enter Transporter Code`);
            }
            const matchedVehicleCapacity = findByFieldIgnoreCase(vehicleCapacityData, "vehicle_cap", vehicleCapacityInput);
            let vehicleCapacity = matchedVehicleCapacity ? matchedVehicleCapacity.vehicle_cap : vehicleCapacityInput;
            if (!matchedVehicleCapacity) {
                rowErrors.push(`Vehicle Capacity - "${vehicleCapacityInput}" does not exist in available vehicles".`);
            }

            // ---- Collect Errors ----
            if (rowErrors.length > 0) {
                errorList.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {
                cleanedData.push({
                    zone: hubName,
                    transporter_name: transporterName,
                    transporter_code: transporterCode,
                    vehicle_capacity: vehicleCapacity,
                    // optional column - checked as a whole in handleBulkUpload (bulkChildCodesProblem)
                    child_codes: String(getCellValue(row, "TRANSPORTER CHILD CODES") || "").trim()

                });
            }
        });

        if (cleanedData.length == 0 && errorList.length == 0) {
            errorList.push({
                row: "",
                errors: ["No Data found. All rows are empty"]
            });
        }

        setErrors(errorList);
        setValidData(cleanedData);

        console.log("Valid Data:", cleanedData);
        console.log("Errors:", errorList);
    };



    const checkTransporterIdentity = (transporter_name) => {
        return transporterData.some(
            (each) => (each.transporter_name === transporter_name)
        );
    };

    var errTrueUpload = errors.length > 0 && validData.length > 0
    var disableUpload = validData.length == 0
    const getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };

    const addNewHubTransporter = () => {
        // var cityArray = this.state.cityList.map((each) => ({ label: each.city, value: each.city, state: each.state }));
        var stateArray = stateData.map((each) => ({ label: each, value: each }));
        // DEDUPE by vehicle_cap - vehicleCapacityData is one row PER ZONE (see addNewRow).
        var vehicleCapacityArray = [...new Set(vehicleCapacityData.map((each) => each.vehicle_cap))]
            .map((each) => ({ label: each, value: each }));
        var transporterArray = transporterData.map((each) => ({ label: each.transporter_name, value: each.transporter_code }));
        const hubArray = [...new Set(hubData.map(e => e.hub_name))].map((each) => ({ label: each, value: each }));
        var transporterResourceArray = [
            // {
            //     id: 1,
            //     title: "Transporter",
            //     field: "transporter_code",
            //     type: "dropdown",
            //     optionsArray: transporterArray,
            //     errMsg: "Please Select Transporter.",
            //     is_active: true,
            //     is_disabled: false,
            //     is_required: true
            // },
            {
                id: 1,
                title: "Transporter Name",
                field: "transporter_name",
                type: "input",
                input_type: "text",
                errMsg: "Please enter Transporter Name.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 1,
                title: "Transporter Code",
                field: "transporter_code",
                type: "input",
                input_type: "text",
                errMsg: "Please enter Transporter Code.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "State",
                field: "state",
                type: "dropdown",
                optionsArray: stateArray,
                errMsg: "Please Select State.",
                is_active: false,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Vehicle Capacity",
                field: "vehicle_cap",
                type: "dropdown",
                optionsArray: vehicleCapacityArray,
                errMsg: "Please Select Vehicle Capacity.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Hub",
                field: "hub",
                type: "dropdown",
                optionsArray: hubArray,
                errMsg: "Please Select Hub.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            childCodesField(() => ({
                loading_port_code: loadingPortCode,
                data_type: 1,
                hub_transporter: 1,
                air_courier_transporter: 0
            }))
        ];
        var titleLabel = "Add New Hub Transporter"

        setController({
            open: true,
            title: titleLabel,
            btnType: "Add",
            formResourceArray: transporterResourceArray,
            type: "add",
            formData: {}
        })
    }

    const editHubTransporter = (params) => {
        // var cityArray = this.state.cityList.map((each) => ({ label: each.city, value: each.city, state: each.state }));
        var stateArray = stateData.map((each) => ({ label: each, value: each }));
        // Was the RAW row list (not {label, value}), so this edit form both duplicated per zone
        // and fed the select objects it could not label. Same deduped shape as the add form now.
        var vehicleCapacityArray = [...new Set(vehicleCapacityData.map((each) => each.vehicle_cap))]
            .map((each) => ({ label: each, value: each }));
        var transporterArray = transporterData.map((each) => ({ label: each.transporter_name, value: each.transporter_code }));
        const hubArray = [...new Set(hubData.map(e => e.hub_name))].map((each) => ({ label: each, value: each }));
        var transporterResourceArray = [
            {
                id: 1,
                title: "Transporter",
                field: "transporter_code",
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please Select Transporter.",
                is_required: true
            },
            {
                id: 2,
                title: "State",
                field: "state",
                type: "dropdown",
                optionsArray: stateArray,
                errMsg: "Please Select State.",
                is_active: false,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Vehicle Capacity",
                field: "vehicle_cap",
                type: "dropdown",
                optionsArray: vehicleCapacityArray,
                errMsg: "Please Select Vehicle Capacity.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Hub",
                field: "hub",
                type: "dropdown",
                optionsArray: hubArray,
                errMsg: "Please Select Hub.",
                is_active: true,
                is_disabled: false,
                is_required: true
            }
        ];
        var titleLabel = "Edit Hub Transporter"
        setController({
            open: true,
            title: titleLabel,
            btnType: "Update",
            formResourceArray: transporterResourceArray,
            type: "update",
            formData: params.data || {}
        })
    }

    const delleteTransporterData = async (data) => {
        // console.log(data)
        var rowIds = data
        // .map((each) => each._id);
        var port = data[0].loading_port_code
        console.log(loadingPortCode, "rowIds")

        if (rowIds.length > 0) {
            setLoadshow("show-m")
            setOverly("show-m")
            var qry = {
                rowIds: rowIds,
                comp_code: compCode,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are you sure you want to delete? The transporter child codes on the deleted row(s) are removed with them.")) {
                redirectURL.post("/lmconsignees/deleteBulkLmHubTransporter", qry).then(async (response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {

                        //window.location.reload();
                        await getHubTransporterData(port);
                        setShow(true)
                        setBasicType("success")
                        setBasicTitle("Deleted Succesfully")
                        setRowId([])
                        setLoadshow("show-n")
                        setOverly("show-n")
                    }
                    else {

                    }
                }).catch((e) => {
                    console.log(e);
                })
            } else {
                setLoadshow("show-n")
                setOverly("show-n")
            }
        }
        else {
            showValidationAlert("Please select the Row(s) to continue.");
        }
    }
    const handleEdit = async (object) => {
        if (controller.type === "update") {
            var originalData = controller.formData || {};
            var hasChanges = Object.keys(object).some((key) => {
                var newVal = object[key] !== undefined && object[key] !== null ? String(object[key]) : "";
                var oldVal = originalData[key] !== undefined && originalData[key] !== null ? String(originalData[key]) : "";
                return newVal !== oldVal;
            });
            if (!hasChanges) {
                setController({ open: false });
                setShow(true)
                setBasicType("warning")
                setBasicTitle("No Changes Made.")
                return;
            }
        }
        setLoadshow("show-m")
        setOverly("show-m")
        console.log(transporterData, object)
        var correctedObject = {
            "loading_port_code": loadingPortCode,
            "transporter_code": object.transporter_code,
            "transporter_name": object.transporter_name,
            "state": object.hub,
            "zone": object.hub,
            "vehicle_capacity": object.vehicle_cap,
            "vehicle_capacity_id": vehicleCapacityData.find((each) => each.vehicle_cap == object.vehicle_cap).id,
            "status": 1, "hub_transporter": 1,
            "data_type": 1,
            // typed on the Add form (the Edit form has no such field -> nothing sent, list untouched)
            "child_codes": parseChildCodes(object.child_codes),
        }
        await updateHubTransporter([correctedObject], controller.type)
        await getHubTransporterData(loadingPortCode);
        setController({ open: false });
        setLoadshow("show-n")
        setOverly("show-n")
    }
    const handleDelete = (array) => {
        console.log(loadingPortCode)
        delleteTransporterData(array)
    }
    const onExportClick = () => {
        if (gridRef.current && gridRef.current.api) {
            // this.gridRef.current.api.exportDataAsCsv();
            gridRef.current.api.exportDataAsExcel({
                fileName: "transporters.xlsx"
            });
        }
    };
    const closeAlert = () => {
        setShow(false)
    }
    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");
    console.log(formData, stateData, editIndex, errors)
    return (
        <div className="hub-master-container d-flex flex-column card col-xl-12" style={{ height: "90%", margin: "0px", padding: "15px 25px", minHeight: 0, borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
            >
            </SweetAlert>
            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", flexShrink: 0 }}>
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Transporters</h5>
                </div>

                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>

                    {(selectedRows.length > 0 && pageAccess != 2) && <button
                        className="pill-btn pill-btn-danger"
                        onClick={() => { handleDelete(selectedRows.map((each) => each._id) || []) }}
                        disabled={selectedRows.length == 0}
                    >
                        Delete Selected
                    </button>}
                    <button
                        className="pill-btn pill-btn-primary"
                        onClick={onExportClick}
                    >
                        Export Data
                    </button>
                    {/* Tab-wide, not per row: hub transporters keep their own child codes, and
                        this lists each LSP once rather than once per state / vehicle type. */}
                    <button
                        className="pill-btn pill-btn-info"
                        onClick={() => setChildCodesOpen(true)}
                    >
                        Transporter Child Codes
                    </button>
                    {
                        pageAccess != 2 && <>
                            <button
                                className="pill-btn pill-btn-info"
                                onClick={() => {
                                    setErrors([]);
                                    setValidData([]);
                                    setFileName("");
                                    setShowBulkSlider(true);
                                }}
                            >
                                Import Data
                            </button>
                            <button
                                className="pill-btn pill-btn-success"
                                onClick={() => {
                                    addNewHubTransporter();
                                    var object = loadingPortData.find((each) => each.value == loadingPortCode)
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        loading_port_code: object.value, comp_short_name: object.label
                                    }))
                                }}
                            >
                                + Add
                            </button>
                        </>
                    }
                </div>
            </div>


            <TransporterChildCodesModal
                open={childCodesOpen}
                loadingPortCode={loadingPortCode}
                dataType={1}
                hubTransporter={1}
                airCourierTransporter={0}
                tabLabel="Hub"
                readOnly={pageAccess == 2}
                onSaved={() => { getHubTransporterData(loadingPortCode); }}
                onClose={() => setChildCodesOpen(false)} />

            {/* GRID */}

            <div className="ag-theme-balham grid-wrapper mt-3" style={{ flex: 1, minHeight: 0 }}>
                <AgGridReact
                    ref={gridRef}
                    modules={modules}
                    rowData={hubTransporterData}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true
                    }}
                    statusBar={{
                        statusPanels: [
                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                            { statusPanel: "agFilteredRowCountComponent", align: "center" },
                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                        ]
                    }}
                    animateRows
                    rowHeight={45}
                    headerHeight={45}
                    frameworkComponents={components}
                    onSelectionChanged={() => {
                        if (gridRef && gridRef.current && gridRef.current.api) {
                            const selected = gridRef.current.api.getSelectedRows();
                            setSelectedRows(selected);
                            // setRowId(selected.map((each) => each._id))
                        }
                    }}
                />
            </div>

            {/* OVERLAY */}
            {showSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}
            {showBulkSlider && (
                <div
                    className="slider-overlay"
                    onClick={() => setShowBulkSlider(false)}
                />
            )}


            <div className={`hub-slider ${showBulkSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    Import Data
                    <span onClick={() => setShowBulkSlider(false)}>✕</span>
                </div>

                <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                    {/* Upload button */}
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-info d-flex justify-content-center p-3"
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            Upload File
                        </button>

                        <a href={require("../../assets/hub_transporters.xlsx")} className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                            Download Sample Template
                        </a>
                    </div>

                    {fileName && (
                        <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                            <span>Selected File :</span>
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                    fontWeight: "bold"
                                }}
                                title={fileName}
                            >
                                {getShortFileName(fileName)}
                            </span>
                        </div>
                    )}


                    {errors.length > 0 && (
                        <>
                            <h6 className="text-danger mt-3">Validation Errors</h6>

                            <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                                <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                    <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                        <tr>
                                            <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                            <th>Error Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {errors.map((err, i) => (
                                            <tr key={i}>
                                                <td className="text-center" style={{ padding: "9px 15px" }}>
                                                    {err.row}
                                                </td>

                                                <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                    {err.errors.map((e, idx) => (
                                                        <p className="m-0" key={idx}>{e}</p>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                        onClick={handleBulkUpload}
                        disabled={disableUpload}
                    >
                        {errTrueUpload ? "Submit only valid data" : "Submit"}
                    </button>
                </div>

            </div>
            {controller.open && (
                <>
                    <div
                        className="slider-overlay"
                        onClick={() => { setController((prevState) => ({ ...prevState, open: false })) }}
                    />
                    <AddEditController
                        resource={controller}
                        onUpdate={handleEdit}
                        closeSlider={() => { setController((prevState) => ({ ...prevState, open: false })) }}
                    />
                </>
            )}


            <div className={"dataLoadpageimg " + (loadshow)} style={{ zIndex: 100 }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>

        </div>
    );
};